import { MutationTuple, useMutation } from '@apollo/client';

import { evictCache } from '../apollo';
import {
  DeletePayrollSyncEventForFiscalYearMutation,
  DeletePayrollSyncEventForFiscalYearMutationVariables,
  DELETE_PAYROLL_SYNC_EVENT_FOR_FISCAL_YEAR,
  GET_FISCAL_YEAR,
} from '../graphql';

type UseDeletePayrollSyncEventForFiscalYear = MutationTuple<
  DeletePayrollSyncEventForFiscalYearMutation,
  DeletePayrollSyncEventForFiscalYearMutationVariables
>;

export const useDeletePayrollSyncEventForFiscalYear = (fiscalYearId: string): UseDeletePayrollSyncEventForFiscalYear =>
  useMutation<DeletePayrollSyncEventForFiscalYearMutation, DeletePayrollSyncEventForFiscalYearMutationVariables>(
    DELETE_PAYROLL_SYNC_EVENT_FOR_FISCAL_YEAR,
    {
      refetchQueries: [
        {
          query: GET_FISCAL_YEAR,
          variables: {
            fiscalYearId,
          },
        },
      ],
      awaitRefetchQueries: true,
      update: (cache) => {
        evictCache(cache, [
          'getCompany',
          'getContributor',
          'getTicketingUsers',
          'getRdProjectTeamMembers',
          'getPayrollQres',
          'getPayrollQreSummary',
        ]);
      },
    },
  );
